var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _vm.IsSuccess == false
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger w-50 m-auto",
            attrs: { role: "alert" },
          },
          [
            _c("strong", [
              _vm._v(_vm._s(_vm.translationKeywords.failed) + "!"),
            ]),
            _vm._v("\n        " + _vm._s(_vm.Message) + "\n        "),
            _c(
              "a",
              {
                staticClass:
                  "btn btn-sm btn-secondary w-25 mx-auto mt-2 text-white",
                on: {
                  click: function ($event) {
                    return _vm.OpenAP("_self")
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.translationKeywords.retry))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.IsSuccess == true
      ? _c(
          "div",
          {
            staticClass: "alert alert-success w-50 m-auto",
            attrs: { role: "alert" },
          },
          [
            _c("strong", [
              _vm._v(_vm._s(_vm.translationKeywords.success) + "!"),
            ]),
            _vm._v("\n        " + _vm._s(_vm.Message) + "\n    "),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }